import './error-item.less';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';

const ErrorItem: React.FC<{ text: string; width: string; height: string }> = ({ text, width, height }) => {
    const { $t } = useLocaleStore();

    return (
        <div
            className="c-aiExpendImage-errorItem"
            style={{
                width: `${120}px`,
                height: `${(120 / parseInt(width)) * parseInt(height)}px`,
            }}
        >
            <IconFont name="ExclamationMarkCircleBold" fontSize={28} color="var(--content-system-quinary)" />
            <span className="text">
                {$t((v, { r }) => r(v.collapse.moreCollapse.imageTool.messageError.aiFailed, [text]))}
            </span>
            <span className="text">{$t((v) => v.collapse.moreCollapse.imageTool.messageError.meidouReturned)}</span>
        </div>
    );
};

export default ErrorItem;
